import { Object3D } from "three";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { BatchedRenderer, QuarksUtil } from "three.quarks";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";
import { Ticker } from "pixi.js";

export class LightningParticle extends Object3D {
    private particles: Object3D;
    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly particlesRenderer: BatchedRenderer
    ) {
        super();
        this.particles = clone(this.gameResources.assets_game_particles_sky_lightning_thjson);
        QuarksUtil.setAutoDestroy(this.particles, true);
        QuarksUtil.addToBatchRenderer(this.particles, this.particlesRenderer);
        this.add(this.particles);
    }

    public async play(): Promise<void> {
        QuarksUtil.play(this.particles);
        await this.waitForEffect();
    }

    private async waitForEffect(durationMS: number = 300): Promise<void> {
        let elapsed = 0;
        return new Promise<void>((resolve) => {
            const tick = (_dt: number) => {
                elapsed += Ticker.shared.elapsedMS;
                if (elapsed >= durationMS) {
                    Ticker.shared.remove(tick, this);
                    resolve();
                }
            }
            Ticker.shared.add(tick, this);
        });
    }
}